import { render } from "./purse.vue?vue&type=template&id=95313584&scoped=true"
import script from "./purse.vue?vue&type=script&lang=js"
export * from "./purse.vue?vue&type=script&lang=js"

import "./purse.vue?vue&type=style&index=0&id=95313584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95313584"]])

export default __exports__